import React from "react";
import { NavLink } from "react-router-dom";
import "./UniversalSidebar.css";

const UniversalSidebar = ({ isOpen, onClose }) => {
  const menuItems = [
    { path: "/new-home", icon: "fa-home", label: "Home" },
    { path: "/games", icon: "fa-gamepad", label: "Games" },
    { path: "/new-blog-home", icon: "fa-book", label: "Blog" },
    { path: "/animehub", icon: "fa-film", label: "Anime" },
    { path: "/profile", icon: "fa-user", label: "Profile" },
  ];

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      
      <aside className={`universal-sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        <nav className="sidebar-nav">
          <ul className="sidebar-menu">
            {menuItems.map((item) => (
              <li key={item.path} className="sidebar-item">
                <NavLink
                  to={item.path}
                  className={({ isActive }) => 
                    isActive ? "sidebar-link active" : "sidebar-link"
                  }
                  onClick={onClose}
                >
                  <i className={`fa ${item.icon}`}></i>
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default UniversalSidebar;
